import { render, staticRenderFns } from "./Competitions.vue?vue&type=template&id=6fd209e6&scoped=true&"
import script from "./Competitions.vue?vue&type=script&lang=js&"
export * from "./Competitions.vue?vue&type=script&lang=js&"
import style0 from "./Competitions.vue?vue&type=style&index=0&id=6fd209e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd209e6",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QCard,QCardSection,QBtn,QBadge,QMenu,QBtnGroup,QSelect,QSpace,QTooltip,QInput,QIcon,QSeparator,QTd,QChip,QScrollArea,QDialog});
